import { render, staticRenderFns } from "./nav_top.vue?vue&type=template&id=2f6ddae0&"
import script from "./nav_top.vue?vue&type=script&lang=js&"
export * from "./nav_top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports